import authApiClient from '../features/shared/data/axios.interceptor'
import AudioStore from '@/shared/store/audio.store.tsx'

export const getAudioBufferFromAudioUrl = async (
  audioFileUrl: string
): Promise<AudioBuffer> => {
  const audioContext = AudioStore.getState().audioContext
  const response = await authApiClient.get<ArrayBuffer>(audioFileUrl, {
    responseType: 'arraybuffer',
  })
  const arrayBuffer = response.data
  return await audioContext.decodeAudioData(arrayBuffer)
}
